import React, { useState } from "react";
import { Formik } from "formik";
import { Button, Grid, FormControl, InputAdornment, InputLabel, OutlinedInput, CircularProgress } from "@material-ui/core";
import { PollPanelStyle } from '../../../infrastructure/PollPanelStyle';


export const EditQuestion = ({ dataEdit, editQuestion}) => {
    const classes = PollPanelStyle();
    const [isLoanding, setisLoanding] = useState(false)

    return (
        <Formik

            initialValues={{
                pregunta: dataEdit.description
               
            }}

            validate={(valores) => {
            
                let errores = {};

                if (!valores.pregunta) {
                    errores.pregunta = 'Por favor ingresa una pregunta valida'
                } else if (!/^[a-z0-9A-ZÀ-ÿ\s.?.¿./]{1,200}$/.test(valores.pregunta)) {
                    errores.pregunta = 'No se aceptan mas de 200 caracteres'
                }

       
                return errores;

            }}

            onSubmit={(valores, { resetForm }) => {

                setisLoanding(true)

                const data = {
                    id:dataEdit.id,
                    description: valores.pregunta,
                    type:dataEdit.type,
                    poll:dataEdit.poll.id,
                    type_wsp: "string",
                    uuid_template: "string",
                    status: true
                    
                }

                editQuestion(data);
                setTimeout(() => {
                    setisLoanding(false)
                }, 2000);
                

                resetForm();
            }}
        >
            {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} style={{ textAlign: "left" }}>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="pregunta">Pregunta</InputLabel>
                                <OutlinedInput
                                    id="pregunta"
                                    type="total"
                                    name='pregunta'
                                    defaultValue={values.pregunta}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                    style={{borderRadius:'10px'}}
                                />
                            </FormControl>
                            {touched.pregunta && errors.pregunta && <div style={{ color: "red" }}>{errors.pregunta}</div>}
                        </Grid>
                       
                    </Grid>

                    <div className={classes.wrapper}>
                        <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                            <Button
                                disabled={isLoanding}
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", width: "50%",borderRadius:'10px' }}
                            >
                                Editar 
                            </Button>
                        </Grid>
                        {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </form>
            )}
        </Formik>
    );
}